import { memo, PropsWithChildren } from 'react';

function MarketSelectorTableCell({ children }: PropsWithChildren) {
	return (
		<span className="flex items-center justify-end text-right typo-b4 md:typo-t4">
			{children}
		</span>
	);
}

export default memo(MarketSelectorTableCell);
